import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMeta = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1567 1041",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "g1",
			x1: 332.6,
			y1: 637.7,
			x2: 1411,
			y2: 692.2,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#0064e1"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .4,
					stopColor: "#0064e1"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .8,
					stopColor: "#0073ee"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0082fb"
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "g2",
			x1: 245.4,
			y1: 757.6,
			x2: 245.4,
			y2: 359.7,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#0082fb"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0064e0"
			})]
		})] }),
		/* @__PURE__ */ _jsx("style", { children: "\n		.s0 { fill: #0081fb }\n		.s1 { fill: url(#g1) }\n		.s2 { fill: url(#g2) }\n	" }),
		/* @__PURE__ */ _jsx("path", {
			id: "Logo0",
			className: "s0",
			d: "m169.5 686.5c0 59.9 13.1 105.8 30.3 133.6 22.5 36.4 56 51.8 90.2 51.8 44.2 0 84.5-10.9 162.3-118.6 62.3-86.2 135.7-207.3 185.1-283.3l83.7-128.6c58.1-89.3 125.3-188.6 202.5-255.9 62.9-55 130.9-85.5 199.2-85.5 114.8 0 224.1 66.5 307.7 191.4 91.6 136.7 136 308.8 136 486.5 0 105.6-20.8 183.2-56.2 244.6-34.2 59.3-100.8 118.5-213 118.5v-169.1c96 0 120-88.3 120-189.3 0-144-33.6-303.8-107.5-418-52.4-81-120.4-130.5-195.2-130.5-80.8 0-145.9 61.1-219.1 169.9-38.9 57.8-78.8 128.3-123.6 207.8l-49.4 87.5c-99.1 175.9-124.2 216-173.8 282.1-86.8 115.7-161 159.6-258.7 159.6-115.8 0-189.1-50.2-234.4-125.8-37.1-61.7-55.3-142.6-55.3-234.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Logo1",
			className: "s1",
			d: "m133.7 203.3c77.6-119.6 189.5-203.3 317.9-203.3 74.3 0 148.2 22 225.4 85.1 84.4 68.9 174.4 182.5 286.7 369.6l40.2 67.1c97.2 162 152.5 245.3 184.8 284.6 41.6 50.5 70.8 65.5 108.6 65.5 96 0 120-88.3 120-189.3l149.2-4.7c0 105.6-20.8 183.2-56.2 244.6-34.2 59.3-100.8 118.5-213 118.5-69.7 0-131.5-15.2-199.8-79.6-52.5-49.5-113.9-137.4-161.1-216.5l-140.4-234.8c-70.5-117.8-135.2-205.6-172.6-245.4-40.2-42.8-92-94.5-174.5-94.5-66.9 0-123.6 46.9-171.1 118.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Logo2",
			className: "s2",
			d: "m448.9 170.2c-66.9 0-123.6 46.9-171.1 118.7-67.2 101.4-108.3 252.5-108.3 397.6 0 59.9 13.1 105.8 30.3 133.6l-144.2 95.1c-37.1-61.7-55.3-142.6-55.3-234.7 0-167.6 46-342.3 133.4-477.2 77.6-119.6 189.5-203.3 317.9-203.3z"
		})
	]
});
export default SvgMeta;
